export default __webpack_public_path__ + "static/350-162f11c3ab53135524f1dbda4a5acfce.gif";